import { Pin, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import useLocalSettings from '@/stores/useLocalSettings';

import type { ModalProps } from '../providers/ModalProvider/ModalProvider';
import { Button } from '../shadcn/button';

export default function PinReminderModal({ onClose }: ModalProps) {
  const { t } = useTranslation();

  const { dismissPinReminder } = useLocalSettings((state) => state.actions);

  const handleDismiss = () => {
    dismissPinReminder();
    onClose();
  };

  return (
    <div className="relative flex flex-col items-center gap-4 p-4">
      <Button
        className="absolute top-2 right-2"
        variant="ghost"
        size="icon-xs"
        onClick={onClose}
      >
        <X />
      </Button>

      <Pin className="text-primary-500 mt-4" />

      <div className="flex flex-col items-center">
        <p className="font-medium">{t('PIN_REMINDER_TITLE')}</p>

        <p className="text-muted-foreground text-center">
          {t('PIN_REMINDER_DESC')}
        </p>
      </div>

      <div className="bg-primary-50/50 dark:bg-primary-900 flex flex-col rounded px-2.5 py-2">
        <p className="text-primary-700 dark:text-primary-100 text-sm font-medium">
          {t('PIN_REMINDER_INSTRUCTION_TITLE')}
        </p>

        <p className="text-primary-700/80 dark:text-primary-100/80 text-xs">
          {t('PIN_REMINDER_INSTRUCTION_DESC')}
        </p>
      </div>

      <div className="flex w-full flex-col gap-1">
        <Button onClick={handleDismiss}>{t('PIN_REMINDER_CONFIRM')}</Button>

        <Button variant="secondary" onClick={handleDismiss}>
          {t('PIN_REMINDER_DONT_SHOW')}
        </Button>
      </div>
    </div>
  );
}
